<template>
  <div class="wrap" :style="{ 'filter': 'brightness(' + brightness + '%)', 'height': height - 50 + 'px' }">
    <v-progress-linear v-model="progress"></v-progress-linear>
    <v-btn :style="{width: (100 - widthSize) + '%'}" class="nav-btn left" @click.stop="prev" v-shortkey="['arrowleft']" @shortkey="prev" :ripple="false">
      <v-icon :style="{'left': (widthSize / 3.5) + '%'}">ion-ios-arrow-left</v-icon>
    </v-btn>
    <v-btn :style="{width: (100 - widthSize) + '%'}" class="nav-btn right" @click.stop="next" v-shortkey="['arrowright']" @shortkey="next" :ripple="false">
      <v-icon :style="{'right': (widthSize / 3.5) + '%'}">ion-ios-arrow-right</v-icon>
    </v-btn>
    <div class="book-content" :style="{'width': widthSize + '%', 'background-color': currentColor, 'height': height - 78 + 'px' }"  @mouseenter="over" @mouseleave="out">
      <v-touch class="book-page touch-swipe" :class="fontFamily" :style="{ 'font-size': fontSize + 'px', 'columns': cols }" :key="div" @tap="rezz" enable-resize-watcher @click="rezz" @mouseover="mouseOver" @swipeleft="next" @swiperight="prev">
        <transition-group :name="routeTransition" mode="out-in">
          <router-view class="default-view" :class="defvscroll" :key="$route.name"></router-view>
        </transition-group>
        <transition-group :name="routeTransition" mode="out-in">
          <router-view class="default-view" :class="defvscroll" :key="$route.name+'l'" name="left" tabindex="2"></router-view>
        <!-- </transition-group>
        <transition-group :name="routeTransition" mode="out-in"> -->
          <router-view class="default-view" :class="defvscroll" :key="$route.name+'r'" name="right" tabindex="3"></router-view>
        </transition-group>
      </v-touch>
    </div>
    <footer :class="fontFamily" :style="{ 'font-size': (fontSize - 5) + 'px' }">
      <div v-if="brandReaderUrl">
      <v-btn flat class="HC-footer-button" @click.native.stop="drawer = false, info = false, buyMenu = false, socialMenu = false, drawerRight = false, otherBooks = false" :ripple="false" tag="a" :href="brandReaderUrl" target="_blank">
        <i><img :src="brandLogoUrl"></i>
      </v-btn>
      </div>
      <v-spacer></v-spacer>
      <div class="foots">
      <span><em>{{ this.$route.name }}</em></span>
      </div>
      <v-spacer></v-spacer>
    </footer>  
  </div>
</template>

<script>
import eventHub from "../event-hub.js"
import Settings from "../components/Settings"

export default {
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px", //"1 auto",
      defvscroll: "",
      zoomViaCols: true,
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      isOver: false,
      routeNames: [
        "home",
        "tcpage1",
        "tcpage2",
        "last"
      ],
      routeTransition: "slide-left",
      rest: true,
      progress: 0,
      height: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/1A1o5Ak/",
      height: 0
    }
  },
  created: function() {
    document.addEventListener("mousewheel", this.onScroll, false)
    // window.addEventListener('resize', this.resize)
    window.addEventListener('resize', this.resize)
    this.resize()
    this.getTtlPages()

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }
    this.$router.options.routes.forEach(route => {
      this.routeNames.push(route.name);
    });
    // this.mouseOver();
    eventHub.$on("fontSizeChanged", newValue => {
      this.fontSize = newValue;
    });
    eventHub.$on("fontFamilyChanged", newValue => {
      this.fontFamily = newValue;
    })
    eventHub.$on("columnsCountChanged", newValue => {
      this.columns = newValue;
      if (this.columns === "Single") {
        this.cols = "1 auto";
        this.defvscroll = "yscroll";
      } else if (this.columns === "Auto") {
        this.cols = "2 220px";
        this.defvscroll = "";
      }
    });
    eventHub.$on("widthChanged", newValue => {
      this.widthSize = newValue;
    });
    eventHub.$on("brightnessChanged", newValue => {
      this.brightness = newValue;
    });
  },
  destroyed: function() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false)
    this.getTtlPages();
  },
  updated() {
    this.getTtlPages();
    this.resize();
    this.mouseOver();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function(e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        }; 
      };
    };

  },
  mounted() {
    this.resize()
    this.getTtlPages()
    this.mouseOver()

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function(e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
    
    const bgColor = document.getElementsByClassName("book-content")[0].style
        .backgroundColor,
      hexDigits = new Array(
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f"
      )
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3])
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16]
    }
    this.currentColor = rgb2hex(bgColor)
  },
  watch: {
    $route(to, from, next) {
      const toDepth = this.routeNames.indexOf(to.name)
      const fromDepth = this.routeNames.indexOf(from.name)
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left"

      this.progress = 0
      this.pageNumber = 1
    },
    pageNum: newValue => {
      eventHub.$emit("pageNum", newValue)
    },
    ttlPages: newValue => {
      eventHub.$emit("ttlPages", newValue)
    }
  },
  methods: {
    mouseOver() {
      var page = this.$el.querySelector(".book-page");
      const ZOOM_VIA_COLS = this.zoomViaCols;
      if (ZOOM_VIA_COLS) {
        if (this.cols === "1 auto") {
          page.style.cursor = 'zoom-out'
        } else {
          page.style.cursor = 'zoom-in'
        }
      } else { // zoom via page width
        if (this.widthSize === 40) {
          page.style.cursor = 'zoom-in'
        } else {
          page.style.cursor = 'zoom-out'
        }
      }
      
      
    },
    resize() {
      this.height = document.documentElement.clientHeight
    },
    rezz() {
      const ZOOM_VIA_COLS = this.zoomViaCols;;
      if (ZOOM_VIA_COLS) {
        if (this.cols === "1 auto") {
          eventHub.$emit("columnsCountChanged", "Auto")
        } else {
          eventHub.$emit("columnsCountChanged", "Single")
        }
      } else { // zoom via page width
        if (this.widthSize === 40) {
          this.widthSize = 70
          eventHub.$emit("columnsCountChanged", "Auto")
        } else {
          this.widthSize = 
          eventHub.$emit("columnsCountChanged", "Single")
        }
        var content = this.$el.querySelector(".book-content")
        content.style.width = this.widthSize + "%"
      }

    },
    scrollDown() {
      const parent = this.$el.querySelector(".book-content")
      const content = this.$el.querySelector(".book-page");
      content.scrollBy({
        top: parent.clientHeight,
        left: 0,
        behaviour: 'smooth'
      })
    },
    scrollUp() {
      const parent = this.$el.querySelector(".book-content")
      const content = this.$el.querySelector(".book-page");
      content.scrollBy({
        top: -parent.clientHeight,
        left: 0,
        behaviour: 'smooth'
      })
    },
    linkTo(refName) {
      const element = document.getElementById(refName)
      const elementOffset = Math.ceil(element.offsetLeft)
      const page = this.$el.querySelector(".book-page")
      const gap = parseInt(
        window.getComputedStyle(page).getPropertyValue("column-gap"),
        10
      )
      const onStart = Math.ceil(page.scrollLeft)
      const onStartPage = Math.floor(onStart / (page.offsetWidth + gap))
      const destinationOffset = Math.floor(
        elementOffset / (page.offsetWidth + gap)
      )
      const target = destinationOffset * (page.offsetWidth + gap) - onStart
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false)
        const scrollArea = page.scrollWidth - page.offsetWidth
        var pctScrolled = Math.floor(
          destinationOffset * (page.offsetWidth + gap) / scrollArea * 100
        )
        this.progress = pctScrolled
        this.pageNumber = destinationOffset + 1
      }
    },
    getTtlPages() {
      this.$nextTick(function() {
        const page = this.$el.querySelector(".book-page")

        const gap = parseInt(
          window.getComputedStyle(page).getPropertyValue("column-gap"),
          10
        )

        const scrollArea = page.scrollWidth - page.offsetWidth
        const ttlPages = Math.round(scrollArea / (page.offsetWidth + gap))
        this.ttlPages = ttlPages
        this.totalPages = this.ttlPages + 1
      })
    },
    tapped() {
      const el = this.$el.querySelector(".touch-swipe")
      this.hiddenEl = !this.hiddenEl
    },
    tappedIn() {
      const el = this.$el.querySelector(".touch-swipe")
      this.hiddenEl = !this.hiddenEl
    },
    scrollIt(destination, duration = 200, easing = "easeInOutQuart", callback) {
      const easings = {
        linear(t) {
          return t
        },
        easeInQuad(t) {
          return t * t
        },
        easeOutQuad(t) {
          return t * (2 - t)
        },
        easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
        },
        easeInCubic(t) {
          return t * t * t
        },
        easeOutCubic(t) {
          return --t * t * t + 1
        },
        easeInOutCubic(t) {
          return t < 0.5
            ? 4 * t * t * t
            : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
        },
        easeInQuart(t) {
          return t * t * t * t
        },
        easeOutQuart(t) {
          return 1 - --t * t * t * t
        },
        easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t
        },
        easeInQuint(t) {
          return t * t * t * t * t
        },
        easeOutQuint(t) {
          return 1 + --t * t * t * t * t
        },
        easeInOutQuint(t) {
          return t < 0.5
            ? 16 * t * t * t * t * t
            : 1 + 16 * --t * t * t * t * t
        }
      }

      const page = this.$el.querySelector(".book-page")
      const gap = parseInt(
          window.getComputedStyle(page).getPropertyValue("column-gap"),
          10
        ),
        offset = page.offsetWidth + gap

      const start = Math.ceil(page.scrollLeft)

      const startTime =
        "now" in window.performance ? performance.now() : new Date().getTime()

      const documentWidth = Math.max(
        page.scrollWidth || page.offsetWidth || page.clientWidth
      )

      const windowWidth = window.innerWidth || window.clientWidth

      const destinationOffsetToScroll = start + destination

      function scroll() {
        const now =
          "now" in window.performance
            ? performance.now()
            : new Date().getTime()
        const time = Math.min(1, (now - startTime) / duration)
        const timeFunction = easings[easing](time)
        page.scroll(
          Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start),
          0
        )
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback()
          }
          return
        }
        requestAnimationFrame(scroll)
      }
      scroll()
    },

    next: function(e) {
      const el = this.$el.querySelector(".touch-swipe")
      el.style.pointerEvents = "auto"
      const book = this.$el.querySelector(".book-content")
      const page = this.$el.querySelector(".book-page"),
        gap =
          parseInt(
            window.getComputedStyle(page).getPropertyValue("column-gap"),
            10
          ) || 0,
        offset = page.offsetWidth + gap,
        index = this.routeNames.indexOf(this.$route.name)
      const scrollArea = page.scrollWidth - page.offsetWidth
      const windowWidth = window.innerWidth || window.clientWidth
      const trackLength = scrollArea - (page.offsetWidth + gap)
      const scrollLeft = Math.ceil(page.scrollLeft)
      let pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap))

      
      console.log('nexxting');
      console.log(page.children);

      this.pageNum = pageNum

      pageNum += 1

      this.pageNumber += 1

      console.log("scrollLeft : "+scrollLeft + " pageNum : "+pageNum);

      if (
        page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 &&
        (typeof(pctScrolled)==='undefined' || pctScrolled !== 100)
      ) {
        const currentPage = Math.floor(pageNum * (page.offsetWidth + gap))

        const nextPage = Math.floor(pageNum * (page.offsetWidth + gap))

        const destination = nextPage - scrollLeft

        this.scrollIt(destination, 300, "easeOutQuad", false)

         // console.log('nexxting into same spread');
         // console.log("currentPage : "+currentPage + " nextPage : "+nextPage + " destination : "+destination);
         // console.log(page);
        // page.children[2].children[0].focus();

      } else {
        // this.scrollIt(-(page.offsetWidth + gap), 2, "linear",
          // () => {
            this.$router.push(
              { name: this.routeNames[index + 1] }, 
              () => {
                      // setTimeout(() => loader.hide(), 3 * 1000)
                      // console.log('nexxting to new spread');
                      // console.log("currentPage : "+currentPage + " nextPage : "+nextPage + " destination : "+destination);
                      // console.log(page);
                      // console.log(this.$el.querySelector(".book-page").children[1].children[0]);
                      // setTimeout(() => this.$el.querySelector(".book-page").children[1].children[0].focus(), .5 * 1000);
                    }
              )

            this.pageNumber = 1
            pageNum = 0
            this.resetScroll();
          // }
        // )
        
        // var pctScrolled = Math.floor(
        //   pageNum * (page.offsetWidth + gap) / scrollArea * 100
        // )
        // this.progress = pctScrolled
      }
      var pctScrolled = Math.floor(
        pageNum * (page.offsetWidth + gap) / scrollArea * 100
      )
      this.progress = pctScrolled
    },
    prev: function(e) {
      const el = this.$el.querySelector(".touch-swipe")
      el.style.pointerEvents = "auto"

      const page = this.$el.querySelector(".book-page"),
        gap = parseInt(
          window.getComputedStyle(page).getPropertyValue("column-gap"),
          10
        ) || 0,
        offset = page.offsetWidth + gap,
        index = this.routeNames.indexOf(this.$route.name)

      const scrollArea = page.scrollWidth - page.offsetWidth

      
      const scrollLeft = Math.ceil(page.scrollLeft)
      let pageNum = Math.round(scrollLeft / (page.offsetWidth + gap))
      const ttlPages = Math.round(scrollArea / (page.offsetWidth + gap))

      this.pageNum = pageNum

      this.pageNumber -= 1

      const currentPage = Math.floor(pageNum * (page.offsetWidth + gap))

      if (scrollLeft !== 0 && pageNum !== 0) {
        let pageNum = Math.round(scrollLeft / (page.offsetWidth + gap))
        const pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap))

        pageNum -= 1
        const prevPage = Math.floor(pageNum * (page.offsetWidth + gap))

        const destination = -1 * (scrollLeft - prevPage)

        this.scrollIt(destination, 300, "easeOutQuad", false)

        // page.children[1].children[0].focus();

        // console.log("must show page 1 of the same spread")

      } else {
        this.$router.push(
          { name: this.routeNames[index - 1] },
          () => {
                  // console.log("tentative PageStartX :" + Math.floor(1 * (page.offsetWidth + gap)));
                  var dest = Math.floor(1 * (page.offsetWidth + gap)) - scrollLeft;
                  this.scrollIt(dest, 30, "easeOutQuad", false);
                  // setTimeout(() => this.$el.querySelector(".book-page").children[2].children[0].focus(), .5 * 1000);
                }
        )

        this.pageNumber = 1

        pageNum = 0
        var pctScrolled = Math.floor(
          pageNum * (page.offsetWidth + gap) / scrollArea * 100
        )
        this.progress = pctScrolled

        // page.children[2].children[0].focus();
        // console.log("must show page 2 of the new spread")
        // console.log("scrollLeft : "+scrollLeft + " pageNum : "+pageNum);
      }
      var pctScrolled = Math.floor(
        pageNum * (page.offsetWidth + gap) / scrollArea * 100
      )
      this.progress = pctScrolled
    },
    over: function() {
      this.isOver = true
    },
    out: function() {
      this.isOver = false
    },
    onScroll: function(e, position) {
      this.position = position
      if (this.isOver === true) {
        const page = this.$el.querySelector(".book-page"),
          gap = parseInt(
            window.getComputedStyle(page).getPropertyValue("column-gap"),
            10
          ),
          deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
          end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
          offset = page.offsetWidth + gap

        const scrollArea = page.scrollWidth - page.offsetWidth
        let pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap))

        var pctScrolled = Math.floor(
          pageNum * (page.offsetWidth + gap) / scrollArea * 100
        )
        this.progress = pctScrolled

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            pageNum -= 1

            this.pageNumber -= 1
            const prevPage = Math.floor(pageNum * (page.offsetWidth + gap))

            const destination = -1 * (page.scrollLeft - prevPage)

            this.scrollIt(destination, 300, "easeOutQuad", false)

            var pctScrolled = Math.floor(
              pageNum * (page.offsetWidth + gap) / scrollArea * 100
            )
            this.progress = pctScrolled
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            pageNum += 1

            this.pageNumber += 1
            const nextPage = Math.floor(pageNum * (page.offsetWidth + gap))

            const destination = nextPage - page.scrollLeft

            this.scrollIt(destination, 300, "easeOutQuad", false)

            var pctScrolled = Math.floor(
              pageNum * (page.offsetWidth + gap) / scrollArea * 100
            )
            this.progress = pctScrolled
          }
        }
      } else {
        return
      }
    },
    fadeIn: function() {
      const page = this.$el.querySelector(".book-page")
      page.style.opacity = 0
      let last = +new Date()
      const tick = function() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400
        last = +new Date()
        if (+page.style.opacity < 1) {
          (window.requestAnimationFrame && requestAnimationFrame(tick)) ||
            setTimeout(tick, 16)
        }
      }
      tick()
    },

    resetScroll: function() {
      const page = this.$el.querySelector(".book-page")
      page.scrollLeft = 0
    }
  },
  computed: {},
  components: {
    Settings
  }
}
</script>


<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

html {
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100%;
}

body {
  font-family: 'Raleway', sans-serif;
  text-align: center;
  color: #f3f3f3;
  overflow: hidden;
  background-color: #504f4d;
  fill: currentColor !important;
  color: orange !important;
  height: 100%;
}

main {
  padding: 0;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
  li {
    display: inline-block;
    margin: 0 10px;
  }
}

a {
  color: #0074D9;
  text-decoration: none;
  transition: all .3s ease-out;
  &:hover {
    color: #4BACB8;
  }
  &:not([href]) {
    color: #2c3e50 !important;
    &:hover, &:active, &:focus {
      color: #2c3e50 !important;
    }
  }
}

svg {
  border: 5px solid currentColor !important;
  fill: currentColor !important;
}

table {
  border-collapse: collapse;
  border-width: 0.5pt;
  border-style: solid;
  border-color: grey;
}

blockquote {
  border-left: 5px solid #4BACB8;
}

.info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #2c3e50;
  opacity: .5;
  z-index: 10;
}

.dialog__content {
  z-index: 22 !important;
  opacity: .95 !important;
  .dialog.dialog--active.dialog--fullscreen .infoDialog {
    height: 100vh !important;
    font-size: 17px;
    i {
      color: #f3f3f3;
      font-size: 25px;
    }
    .menuIns {
      position: absolute;
      top: 0;
      left: 0;
      width: 80px;
      height: 50px;
      i {
        padding: 12px 20px;
      }
    }
    .menuInsTip {
      position: absolute;
      top: 55px;
      left: 25px;
      width: 180px;
      padding: 0 10px 10px;
      border: 1px solid #f3f3f3;
      border-radius: 0 15px 15px 15px;
    }
    .socMenu {
      position: absolute;
      top: 0;
      left: 100px;
      height: 50px;
      padding: 5px 0;
      i {
        padding: 10px 18px;
        font-size: 17px;
      }
    }
    .socMenuMob {
      position: absolute;
      top: 0;
      left: 20vw;
      padding: 5px 0;
      width: 20vw;
      i {
        padding: 9px 18px;
        font-size: 20px;
        color: #f3f3f3;
      }
    }
    .socMenuTip {
      position: absolute;
      top: 55px;
      left: 300px;
      padding: 0 10px 10px;
      width: 200px;
      border: 1px solid #f3f3f3;
      border-radius: 0 15px 15px 15px;
    }
    .resize-settings {
      position: absolute;
      right: 0;
      top: 0;
      width: 70px;
      padding: 12px 0;
      i {
        color: #f3f3f3;
        font-size: 26px !important;
      }
    }
    .resize-settings-tip {
      position: absolute;
      right: 25px;
      top: 55px;
      border: 1px solid #f3f3f3;
      border-radius: 15px 0 15px 15px;
      width: 220px;
      padding: 0 10px 8px;
    }
    .info-button {
      position: absolute;
      top: 0;
      right: 71px;
      width: 50px;
      height: 50px;
      padding-top: 10px;
    }
    .info-button-tip {
      position: absolute;
      top: 3px;
      right: 125px;
      width: 250px;
      border: 1px solid #f3f3f3;
      padding: 0 10px 10px;
      border-radius: 15px 0 15px 15px;
    }
    .left-button {
      position: absolute;
      top: 45vh;
      left: 100px;
      padding: 10px 20px;
    }
    .left-button-tip {
      position: absolute;
      top: calc(45vh + 50px);
      left: 170px;
      border: 1px solid #f3f3f3;
      padding: 0 10px 10px;
      border-radius: 0 15px 15px 15px;
      width: 200px;
    }
    .right-button {
      position: absolute;
      top: 45vh;
      right: 100px;
      padding: 10px 20px;
    }
    .right-button-tip {
      position: absolute;
      top: calc(45vh + 50px);
      right: 170px;
      border: 1px solid #f3f3f3;
      padding: 0 10px 10px;
      border-radius: 15px 0 15px 15px;
      width: 200px;
    }
    .buy-buttons {
      position: absolute;
      top: 45vh;
      left: 0;
      width: 80px;
      padding: 10px;
      i {
        font-size: 35px;
      }
    }
    .buy-buttons-mob {
      position: absolute;
      top: 0;
      left: 40vw;
      width: 20vw;
      padding: 10px;
      i {
        color: #f3f3f3;
      }
    }
    .buy-buttons-tip {
      position: absolute;
      top: calc(37vh + 135px);
      left: 5px;
      border: 1px solid #f3f3f3;
      border-radius: 0 15px 15px 15px;
      width: 120px;
      padding: 0 10px 10px;
    }
    .headline {
      margin: 0 auto;
      padding-top: 40vh;
      width: 100vw;
    }
    .closeDialog {
      color: #f3f3f3;
      background: #4BACB8 !important;
      margin: 0 auto;
      padding: 10px;
      box-shadow: none;
      margin-top: 5px;
      border: 0;
    }
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .menuIns {
    width: 20vw;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .menuInsTip {
    font-size: 14px;
    width: 20vw;
    left: 0;
    padding: 5px;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .socMenu {
    display: none;
  }
}

@media screen and (min-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .socMenuMob {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .socMenuTip {
    font-size: 14px;
    left: 20vw;
    width: 20vw;
    padding: 5px;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .resize-settings {
    width: 20vw;
    left: 80vw;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .resize-settings-tip {
    font-size: 14px;
    left: 80vw;
    width: 20vw;
    top: 53px;
    padding: 5px;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .info-button {
    width: 20vw;
    left: 60vw;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .info-button-tip {
    font-size: 14px;
    left: 60vw;
    width: 20vw;
    top: 53px;
    padding: 5px;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .left-button {
    left: 0;
    top: 55vh;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .left-button-tip {
    width: 40vw;
    left: 3px;
    top: 65vh !important;
    font-size: 14px;
    padding: 5px;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .right-button {
    right: 0;
    top: 55vh;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .right-button-tip {
    width: 40vw;
    right: 3px;
    top: 65vh !important;
    font-size: 14px;
    padding: 5px;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .buy-buttons {
    display: none;
  }
}

@media screen and (min-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .buy-buttons-mob {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .buy-buttons-tip {
    font-size: 14px;
    top: 55px;
    left: 40vw;
    width: 20vw;
    padding: 5px;
  }
}

@media screen and (max-width: 768px) {
  .dialog__content .dialog.dialog--active.dialog--fullscreen .infoDialog .headline {
    padding-top: 50vh;
  }
}

.overlay.overlay--active {
  background: #2C2F30;
  z-index: -1 !important;
}

.infoDialog {
  background-color: #2C2F30 !important;
  color: #f3f3f3 !important;
}

[data-tooltip] {
  &[data-tooltip-location='bottom']:before {
    top: 100%;
    left: 50%;
    -webkit-transform: translate3d(-50%, -14px, 0) scale(0);
    transform: translate3d(-50%, -14px, 0) scale(0);
    -webkit-transform-origin: center top;
    transform-origin: left top;
  }
  &:before {
    color: #282c34;
    background: rgba(243, 243, 243, 0.5);
    background: #f3f3f3;
    box-shadow: none;
    z-index: 99;
  }
  &:hover:before {
    opacity: 1 !important;
  }
}

.main-menu-button[data-tooltip][data-tooltip-location='bottom']:before {
  left: 100%;
  top: 90%;
}

.desktop-social-btn .btn[data-tooltip][data-tooltip-location='bottom']:before {
  left: 200%;
}

.settings-button[data-tooltip][data-tooltip-location='bottom']:before {
  left: -0%;
}

.lib-item-size {
  height: 30px;
  .input-group {
    display: inline-block;
    float: right;
    width: 100px;
  }
  i {
    display: inline-block;
    cursor: pointer;
    margin: -14px 5px 0 0;
    padding: 15px;
    border: 1px solid rgba(75, 172, 184, 0);
    &:hover, &:active, &:focus {
      color: #4BACB8;
    }
  }
}

.default-view {
  max-height: calc(100vh - 115px) !important;
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE 10+ */
  &::-webkit-scrollbar { /* WebKit */
    width: 0;
    height: 0;
  }
    &.book {
        /*column-count: 2;*/
        column-gap:5px;
        overflow-y: visible;
        .coverInfo img.coverImage {
            /*margin: 0;*/
        }
        .bookInfo{
          padding: 0 8px;
            h1.bookTitle {
                font-size: 55px;
                line-height: 55px;
                margin: 10px 0;
            }
            p.bookDescription, p {
                font-size: 18px;
            }
        }    
        .authorInfo {
            float: left;
            width: 50%;
            h2.authorName {
                font-size: 35px;    
                line-height: 35px;    
                margin: 0;
            }
            a.authorURL {
                font-size: 18px !important;
            }
        }
        .publisherInfo {
            float: left;
            width: 50%;
            h2.publisherName {
                font-size: 35px !important;   
                line-height: 35px !important;    
                margin: 0;
            }
            a.publisherURL {
                font-size: 18px !important;
            }
        }     
    }
}

.overlay, .overlay--absolute, .overlay--active {
  opacity: .5;
  z-index: 3;
  background-color: #2c3e50;
}

nav {
  background-color: #f3f3f3 !important;
}

.btn--active .btn__content:before {
  background-color: #f3f3f3;
}

.btn {
  &:hover .btn__content:before, &:focus .btn__content:before {
    background-color: #f3f3f3;
  }
}

.main-menu {
  &.toolbar {
    z-index: 20 !important;
    box-shadow: none;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1), 0 1px 6px rgba(0, 0, 0, 0.2) !important;
  }
  background-color: #f3f3f3 !important;
  height: 50px;
  z-index: 5 !important;
  padding: 0 10px 0 !important;
  .toolbar__content {
    height: auto;
  }
  button {
    min-width: 50px !important;
    width: 70px;
    border-radius: 0;
    height: 50px !important;
    outline: 0;
    margin: 5px;
    margin: 0 auto !important;
    padding: 0 20px;
    i {
      color: #0E0816 !important;
    }
    &:hover, &:active, &:focus {
      opacity: 1;
    }
    &:hover i, &:active i, &:focus i {
      color: #4BACB8 !important;
    }
  }
  ul > span {
    float: left;
    padding: 1rem;
  }
}

@media screen and (max-width: 500px) {
  .main-menu {
    padding: 0 !important;
  }
}

@media screen and (max-width: 768px) {
  .main-menu button {
    max-width: 15vw !important;
  }
}

.navigation-drawer--right {
  z-index: 3 !important;
}

.menu {
  z-index: 3 !important;
  &.navigation-drawer {
    transition: all .2s ease-in-out;
    background-color: #f3f3f3 !important;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.2) !important;
    padding-right: 10px;
    ul.list {
      background-color: #f3f3f3 !important;
      margin-top: 60px;
      margin-right: -25px;
      margin-left: 5px;
      padding-bottom: 80px;
      li a.list__tile, .list__tile--highlighted {
        color: #504f4d !important;
        height: 75px;
        border: 1px solid rgba(75, 172, 184, 0);
      }
      li a.list__tile {
        &:hover, &:active, &:focus {
          color: #4BACB8 !important;
          background-color: rgba(44, 62, 80, 0.05);
          border: 1px solid rgba(75, 172, 184, 0.25);
        }
      }
      .list__tile--highlighted {
        &:hover, &:active, &:focus {
          color: #4BACB8 !important;
          background-color: rgba(44, 62, 80, 0.05);
          border: 1px solid rgba(75, 172, 184, 0.25);
        }
      }
      li a.list__tile .list__tile__action i, .list__tile--highlighted .list__tile__action i, li a.list__tile--active {
        color: #4BACB8 !important;
      }
    }
  }
  .menu__activator {
    font-size: 15px;
    background: rgba(44, 62, 80, 0);
    border: 1px solid rgba(75, 172, 184, 0);
    height: 50px;
    &:hover, &:active, &:focus {
      color: #4BACB8 !important;
      background: rgba(44, 62, 80, 0.05) !important;
      border: 1px solid rgba(75, 172, 184, 0.25);
    }
    .toolbar__title {
      margin-top: 7px;
    }
  }
  .menu__activator--active {
    color: #4BACB8 !important;
    background: rgba(44, 62, 80, 0.05) !important;
    border: 1px solid rgba(75, 172, 184, 0.25);
  }
}

.toolbar__content > *:not(.btn):not(.toolbar__title):not(.menu):last-child, .toolbar__extension > *:not(.btn):not(.toolbar__title):not(.menu):last-child {
  margin-right: 0;
}

.toolbar__content > *:not(.btn):not(.toolbar__title):not(.menu):first-child, .toolbar__extension > *:not(.btn):not(.toolbar__title):not(.menu):first-child {
  margin-left: 0;
  width: 85px;
}

.btn {
  min-width: 0;
}

.buy-menu {
  top: 50px;
  width: 100vw;
  padding: 5px 30px;
  border: 1px solid rgba(75, 172, 184, 0);
  box-shadow: 0 0 0 6px 30px 5px rgba(0, 0, 0, 0.12) !important;
}

.social-menu {
  width: 100vw;
  padding: 5px 30px;
  border: 1px solid rgba(75, 172, 184, 0);
  box-shadow: 0 0 0 6px 30px 5px rgba(0, 0, 0, 0.12) !important;
}

.buy-menu .list, .social-menu .list {
  z-index: 0 !important;
}

.buy-menu .list__tile {
  &:hover, &:active, &:focus {
    color: #4BACB8 !important;
    background: rgba(44, 62, 80, 0.05) !important;
    border: 1px solid rgba(75, 172, 184, 0.25);
  }
}

.social-menu .list__tile {
  &:hover, &:active, &:focus {
    color: #4BACB8 !important;
    background: rgba(44, 62, 80, 0.05) !important;
    border: 1px solid rgba(75, 172, 184, 0.25);
  }
}

.buy-menu .list__tile {
  &:hover img svg, &:active img svg, &:focus img svg {
    fill: #4BACB8 !important;
  }
}

.social-menu .list__tile {
  &:hover img svg, &:active img svg, &:focus img svg {
    fill: #4BACB8 !important;
  }
}

.buy-menu .list__tile__action, .social-menu .list__tile__action {
  font-size: 20px;
}

.buy-menu .list__tile__action img, .social-menu .list__tile__action img {
  height: 22px;
}

.buy-menu .list__tile__action img svg, .social-menu .list__tile__action img svg {
  fill: #4BACB8 !important;
}

.buy-menu.navigation-drawer--close:not(.navigation--permanent).navigation-drawer:not(.navigation-drawer--right), .social-menu.navigation-drawer--close:not(.navigation--permanent).navigation-drawer:not(.navigation-drawer--right) {
  transform: translate3d(0, calc(-100% - 100px), 0);
}

.otherBooks ul.list {
  margin-top: 55px;
  margin-right: -18px;
  padding-right: 18px;
  padding-left: 18px;
  padding-bottom: 100px;
  background-color: #f3f3f3 !important;
  h6 {
    font-size: 18px;
  }
  li {
    max-height: 200px;
    padding: 10px 0;
    .list__tile {
      display: block;
      height: auto;
      padding-top: 10px;
      &:hover {
        background: rgba(75, 172, 184, 0.25);
        color: #4BACB8;
      }
      .list__tile__action {
        height: auto;
        text-align: right;
        margin-bottom: 20px;
        margin-top: 10px;
        img {
          max-width: 200px;
          margin: 0 auto;
        }
      }
      .list__tile__content .list__tile__title {
        text-align: center;
        font-size: 18px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .otherBooks ul.list {
    margin-right: 0;
    padding-right: 0;
    padding-left: 0;
  }
}

.HC, .HC-button, .otherBooks-button, .main-menu-button, .info-btn, .settings-button, .mobile-social-btn, .mobile-buy-btn {
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none;
  border: 0 !important;
  width: 50px !important;
}

.HC {
  &:focus, &:active, &:hover {
    background-color: #f3f3f3;
  }
}

.HC-button {
  &:focus, &:active, &:hover {
    background-color: #f3f3f3;
  }
}

.otherBooks-button {
  &:focus, &:active, &:hover {
    background-color: #f3f3f3;
  }
}

.main-menu-button {
  &:focus, &:active, &:hover {
    background-color: #f3f3f3;
  }
}

.info-btn {
  &:focus, &:active, &:hover {
    background-color: #f3f3f3;
  }
}

.settings-button {
  &:focus, &:active, &:hover {
    background-color: #f3f3f3;
  }
}

.mobile-social-btn {
  &:focus, &:active, &:hover {
    background-color: #f3f3f3;
  }
}

.mobile-buy-btn {
  &:focus, &:active, &:hover {
    background-color: #f3f3f3;
  }
}

.HC {
  &:focus i.icon, &:active i.icon, &:hover i.icon {
    color: #4BACB8 !important;
  }
}

.HC-button {
  &:focus i.icon, &:active i.icon, &:hover i.icon {
    color: #4BACB8 !important;
  }
}

.otherBooks-button {
  &:focus i.icon, &:active i.icon, &:hover i.icon {
    color: #4BACB8 !important;
  }
}

.main-menu-button {
  &:focus i.icon, &:active i.icon, &:hover i.icon {
    color: #4BACB8 !important;
  }
}

.info-btn {
  &:focus i.icon, &:active i.icon, &:hover i.icon {
    color: #4BACB8 !important;
  }
}

.settings-button {
  &:focus i.icon, &:active i.icon, &:hover i.icon {
    color: #4BACB8 !important;
  }
}

.mobile-social-btn {
  &:focus i.icon, &:active i.icon, &:hover i.icon {
    color: #4BACB8 !important;
  }
}

.mobile-buy-btn {
  &:focus i.icon, &:active i.icon, &:hover i.icon {
    color: #4BACB8 !important;
  }
}

@media screen and (max-width: 768px) {
  .HC .HC-button, .HC-button .HC-button, .otherBooks-button .HC-button, .main-menu-button .HC-button, .info-btn .HC-button, .settings-button .HC-button, .mobile-social-btn .HC-button, .mobile-buy-btn .HC-button {
    margin-right: -10px !important;
  }
  .HC {
    &:focus, &:active, &:hover {
      background-color: #f3f3f3;
    }
  }
  .HC-button {
    &:focus, &:active, &:hover {
      background-color: #f3f3f3;
    }
  }
  .otherBooks-button {
    &:focus, &:active, &:hover {
      background-color: #f3f3f3;
    }
  }
  .main-menu-button {
    &:focus, &:active, &:hover {
      background-color: #f3f3f3;
    }
  }
  .info-btn {
    &:focus, &:active, &:hover {
      background-color: #f3f3f3;
    }
  }
  .settings-button {
    &:focus, &:active, &:hover {
      background-color: #f3f3f3;
    }
  }
  .mobile-social-btn {
    &:focus, &:active, &:hover {
      background-color: #f3f3f3;
    }
  }
  .mobile-buy-btn {
    &:focus, &:active, &:hover {
      background-color: #f3f3f3;
    }
  }
  .HC {
    &:focus i.icon, &:active i.icon, &:hover i.icon {
      color: #4BACB8 !important;
      text-shadow: none;
    }
  }
  .HC-button {
    &:focus i.icon, &:active i.icon, &:hover i.icon {
      color: #4BACB8 !important;
      text-shadow: none;
    }
  }
  .otherBooks-button {
    &:focus i.icon, &:active i.icon, &:hover i.icon {
      color: #4BACB8 !important;
      text-shadow: none;
    }
  }
  .main-menu-button {
    &:focus i.icon, &:active i.icon, &:hover i.icon {
      color: #4BACB8 !important;
      text-shadow: none;
    }
  }
  .info-btn {
    &:focus i.icon, &:active i.icon, &:hover i.icon {
      color: #4BACB8 !important;
      text-shadow: none;
    }
  }
  .settings-button {
    &:focus i.icon, &:active i.icon, &:hover i.icon {
      color: #4BACB8 !important;
      text-shadow: none;
    }
  }
  .mobile-social-btn {
    &:focus i.icon, &:active i.icon, &:hover i.icon {
      color: #4BACB8 !important;
      text-shadow: none;
    }
  }
  .mobile-buy-btn {
    &:focus i.icon, &:active i.icon, &:hover i.icon {
      color: #4BACB8 !important;
      text-shadow: none;
    }
  }
}

.HC-button img {
  max-height: 25px !important;
  margin-top: 7px !important;
}

.HC-footer-button {
  margin: 0;
}

.mobile-social-btn {
  display: none;
  padding: 0;
  margin: 0 !important;
  height: 49px !important;
  box-shadow: none;
  border: 0 !important;
  i {
    opacity: .7 !important;
  }
  &:focus, &:active, &:hover {
    box-shadow: none;
  }
}

.mobile-buy-btn {
  display: none;
  padding: 0;
  margin: 0 !important;
  height: 49px !important;
  box-shadow: none;
  border: 0 !important;
  font-weight: bolder !important;
  i {
    opacity: .7 !important;
  }
  &:focus, &:active, &:hover {
    background-color: rgba(0, 0, 0, 0);
    box-shadow: none;
  }
}

.desktop-social-btn {
  box-shadow: none;
  a.btn {
    margin: 0;
    i.icon {
      color: #282c34 !important;
      font-size: 20px;
    }
    &:hover i.icon, &:active i.icon, &:focus i.icon {
      color: #4BACB8 !important;
    }
  }
}

.navigation-drawer__border {
  display: none;
}

.mini-bar.navigation-drawer--mini-variant {
  height: auto !important;
  margin: 0;
  margin-top: 60px;
  padding: 0;
  top: 25%;
  transform: translate3d(0, -50%, 0);
  z-index: 2;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1), 0 1px 6px rgba(0, 0, 0, 0.2) !important;
  ul.list {
    background: #f3f3f3 !important;
    height: auto;
    overflow: hidden;
    a {
      width: 100%;
      &:hover, &:active, &:focus {
        background: rgba(75, 172, 184, 0.1) !important;
      }
      img {
        width: 35px;
        display: block;
        margin: 10px auto;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .mini-bar.navigation-drawer--mini-variant {
    display: block;
  }
}

.settings-drawer {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1), 0 1px 6px rgba(0, 0, 0, 0.2) !important;
  ul.list {
    background-color: #f3f3f3 !important;
    button#black {
      border: 1px solid #f3f3f3 !important;
    }
  }
}

.container {
  padding: 0;
}

.font1, .font2 {
  font-size: 1em;
}

.menu__content {
  width: 200px;
  left: auto !important;
  right: 37px;
  top: 100px !important;
  z-index: 6 !important;
}

.input-group--overflow .input-group__input:before, .input-group--editable .input-group__input:before, .input-group--segmented .input-group__input:before, .input-group__details:before {
  height: 0;
}

.application--light .input-group.input-group--dirty .input-group__selections__comma {
  color: #4BACB8;
  font-weight: bold;
  letter-spacing: 3px;
}

.input-group__selections {
  overflow: visible !important;
}

.bold-font {
  font-weight: bold;
  color: #4BACB8;
  font-size: 17px;
}

.list li {
  width: 100%;
  margin: 0;
}

.input-group--select {
  padding: 0;
  height: 30px;
}

.radio {
  width: 50%;
  float: left;
  padding: 0;
  padding-top: 20px;
}

.input-group__details:after {
  background-color: #4BACB8;
}

.slider {
  height: 0;
}

.slider__thumb {
  cursor: pointer;
}

.input-group--slider.input-group--dirty {
  .slider__thumb {
    background-color: #4BACB8;
    width: 25px;
    height: 25px;
  }
  .slider__thumb--label {
    background-color: #4BACB8;
  }
}

.application--light .input-group--slider:not(.input-group--dirty) {
  &.input-group--ticks .slider__thumb-container .slider__thumb {
    background-color: #4BACB8;
  }
  &:not(.input-group--ticks):focus .slider__thumb {
    background-color: #4BACB8;
    border: 4px solid #4BACB8 !important;
  }
}

.input-group--slider {
  &:not(.input-group--disabled).input-group--dirty .slider__track-fill {
    background-color: #4BACB8;
  }
  height: 30px;
  padding-bottom: 0;
}

.application--light .input-group.input-group--selection-controls {
  &.radio, &.checkbox {
    color: #4BACB8;
  }
}

.input-group--selection-controls {
  height: 60px;
}

.library {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  padding-right: 20px;
  margin-right: -20px;
}

.nav-btn {
  overflow: hidden;
  position: absolute;
  top: 0;
  padding: 20px;
  transition: .3s ease-in-out;
  height: 100vh;
  width: 50%;
  margin: 0;
  &:hover .icon {
    color: #4bacb8 !important;
    text-shadow: 2px 1px 10px rgba(75, 172, 184, 0.5);
  }
  &:focus, &:active {
    opacity: 1 !important;
  }
  img {
    height: 50px;
  }
  .icon {
    height: 100%;
    position: absolute;
    top: 0;
    font-size: 5rem;
    color: rgba(75, 172, 184, 0.5) !important;
  }
  .btn__content:before {
    background-color: rgba(0, 0, 0, 0.75);
  }
  &:active .btn__content:before, &:focus .btn__content:before, &:hover .btn__content:before {
    background-color: #000;
  }
}

.left {
  left: 0;
  .icon {
    left: 80px;
  }
  img {
    transform: rotate(180deg);
  }
}

@media screen and (min-width: 1024px) {
  .left .icon {
    left: 100px;
  }
}

.right {
  right: 0;
  .icon {
    right: 80px;
  }
}

.wrap {
  filter: brightness(100%);
}

.progress-linear {
  position: absolute;
  margin: 0;
  padding: 0;
  bottom: 0 !important;
  z-index: 11;
  height: 5px !important;
  box-shadow: inset -1px 0 2px 5px rgba(0, 0, 0, 0.1) !important;
  .progress-linear__bar {
    background: rgba(243, 243, 243, 0.1);
    opacity: .75;
    .progress-linear__bar__determinate {
      background-color: #4BACB8;
    }
  }
}

footer {
  position: fixed;
  bottom: 0 !important;
  padding: 0 20px !important;
  padding-bottom: 3px !important;
  top: auto !important;
  left: 0;
  width: 100%;
  z-index: 10 !important;
  background: #f3f3f3 !important;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px rgba(0, 0, 0, 0.2), 0 1px 10px rgba(0, 0, 0, 0.2);
  height: auto !important;
  font-size: 22px;
  font-family: 'Old Standard TT';
  .HC-footer-button {
    height: 29px;
    left: 0;
    position: absolute;
    img {
      height: 20px;
    }
  }
}

@media screen and (max-width: 768px) {
  footer .HC-footer-button {
    position: relative;
    float: left;
  }
}

.book-content {
  position: relative;
  background-color: #f3f3f3;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.2);
  max-width: 100%;
  min-width: 500px;
  width: 70%;
  padding: 20px 40px 0;
  overflow: hidden;
  z-index: 2 !important;
  margin-top: 50px;
  margin-left: 50%;
  transform: translate3d(-50%, 0, 0);
  -webkit-transform: translate3d(-50%, 0, 0);
  transition: all 0.35s cubic-bezier(0, 0.74, 0.36, 1);
  height: 100vh;
  max-height: calc(100vh - 50px);
  .slide-right-enter-active, .slide-right-leave-active, .slide-left-enter-active, .slide-left-leave-active, .slide-right-enter, .slide-left-leave-to, .slide-right-enter-to, .slide-left-leave, .slide-right-leave, .slide-left-enter-to, .slide-left-enter, .slide-right-leave-to, .book-page {
    position: relative;
    column-gap: 0px;
    overflow-x: hidden !important;
    overflow-y: hidden !important;
    overflow-y: -moz-hidden-unscrollable !important;
    transition: all 0.35s cubic-bezier(0, 0.74, 0.36, 1);
    text-align: initial;
    color: #2c3e50;
    font-family: 'Old Standard TT';
  }
  .slide-right-enter-active .r-view, .slide-right-leave-active .r-view, .slide-left-enter-active .r-view, .slide-left-leave-active .r-view, .slide-right-enter .r-view, .slide-left-leave-to .r-view, .slide-right-enter-to .r-view, .slide-left-leave .r-view, .slide-right-leave .r-view, .slide-left-enter-to .r-view, .slide-left-enter .r-view, .slide-right-leave-to .r-view, .book-page .r-view {
    width: 50%;
    float: left;
  }
  .slide-right-enter-active {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-right-leave-active {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-left-enter-active {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-left-leave-active {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-right-enter {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-left-leave-to {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-right-enter-to {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-left-leave {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-right-leave {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-left-enter-to {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-left-enter {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-right-leave-to {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .book-page {
    h1, h2, h3, h4, h5, h6 {
      font-family: 'Cabin';
      margin-top: 20px;
      width: 100%;
      max-width: 80%;
      word-break: keep-all;
    }
  }
  .slide-right-enter-active h1, .slide-right-leave-active h1, .slide-left-enter-active h1, .slide-left-leave-active h1, .slide-right-enter h1, .slide-left-leave-to h1, .slide-right-enter-to h1, .slide-left-leave h1, .slide-right-leave h1, .slide-left-enter-to h1, .slide-left-enter h1, .slide-right-leave-to h1, .book-page h1 {
    font-size: 55px;
    line-height: 60px;
    margin-bottom: 30px;
  }
  .slide-right-enter-active h1.chapter, .slide-right-leave-active h1.chapter, .slide-left-enter-active h1.chapter, .slide-left-leave-active h1.chapter, .slide-right-enter h1.chapter, .slide-left-leave-to h1.chapter, .slide-right-enter-to h1.chapter, .slide-left-leave h1.chapter, .slide-right-leave h1.chapter, .slide-left-enter-to h1.chapter, .slide-left-enter h1.chapter, .slide-right-leave-to h1.chapter, .book-page h1.chapter {
    font-size: 55px;
    width: 100%;
  }
  .slide-right-enter-active img, .slide-right-leave-active img, .slide-left-enter-active img, .slide-left-leave-active img, .slide-right-enter img, .slide-left-leave-to img, .slide-right-enter-to img, .slide-left-leave img, .slide-right-leave img, .slide-left-enter-to img, .slide-left-enter img, .slide-right-leave-to img, .book-page img {
    page-break-before: auto;
    page-break-after: auto;
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
    display: block;
  }
  .slide-right-enter-active ul, .slide-right-leave-active ul, .slide-left-enter-active ul, .slide-left-leave-active ul, .slide-right-enter ul, .slide-left-leave-to ul, .slide-right-enter-to ul, .slide-left-leave ul, .slide-right-leave ul, .slide-left-enter-to ul, .slide-left-enter ul, .slide-right-leave-to ul, .book-page ul {
    float: left;
    > li {
      float: left;
    }
  }
  .slide-right-enter-active ul li, .slide-right-leave-active ul li, .slide-left-enter-active ul li, .slide-left-leave-active ul li, .slide-right-enter ul li, .slide-left-leave-to ul li, .slide-right-enter-to ul li, .slide-left-leave ul li, .slide-right-leave ul li, .slide-left-enter-to ul li, .slide-left-enter ul li, .slide-right-leave-to ul li, .book-page ul li {
    width: 100%;
  }
  .slide-right-enter-active {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-right-leave-active {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-left-enter-active {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-left-leave-active {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-right-enter {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-left-leave-to {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-right-enter-to {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-left-leave {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-right-leave {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-left-enter-to {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-left-enter {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-right-leave-to {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .book-page {
    .publisherInfo, .authorInfo {
      float: left;
      width: 100%;
    }
  }
  .slide-right-enter-active .publisherInfo p, .slide-right-leave-active .publisherInfo p, .slide-left-enter-active .publisherInfo p, .slide-left-leave-active .publisherInfo p, .slide-right-enter .publisherInfo p, .slide-left-leave-to .publisherInfo p, .slide-right-enter-to .publisherInfo p, .slide-left-leave .publisherInfo p, .slide-right-leave .publisherInfo p, .slide-left-enter-to .publisherInfo p, .slide-left-enter .publisherInfo p, .slide-right-leave-to .publisherInfo p, .book-page .publisherInfo p {
    width: 100%;
    display: block;
    float: none;
  }
  .slide-right-enter-active {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .slide-right-leave-active {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .slide-left-enter-active {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .slide-left-leave-active {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .slide-right-enter {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .slide-left-leave-to {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .slide-right-enter-to {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .slide-left-leave {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .slide-right-leave {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .slide-left-enter-to {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .slide-left-enter {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .slide-right-leave-to {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      max-height: calc(100vh - 115px) !important;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
  }
  .book-page {
    .coverImage, .seperator img, img {
      max-width: 100%;
      height: auto;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      margin: 0 auto;
    }
    .coverImage, .seperator img{
      max-height: calc(100vh - 115px) !important;
      width: auto;
    }
  }
  .yscroll {
    overflow-y: scroll !important;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE 10+ */
    &::-webkit-scrollbar { /* WebKit */
      width: 0;
      height: 0;
    }
    .coverImage {
      max-height: unset !important;
      width : 95%;
    }
  }
  .slide-right-enter-active span.drop-cap, .slide-right-leave-active span.drop-cap, .slide-left-enter-active span.drop-cap, .slide-left-leave-active span.drop-cap, .slide-right-enter span.drop-cap, .slide-left-leave-to span.drop-cap, .slide-right-enter-to span.drop-cap, .slide-left-leave span.drop-cap, .slide-right-leave span.drop-cap, .slide-left-enter-to span.drop-cap, .slide-left-enter span.drop-cap, .slide-right-leave-to span.drop-cap, .book-page span.drop-cap {
    font-size: 2.8em;
    line-height: 1.3em;
    margin-right: 10px;
    margin-bottom: -.5em;
    float: left;
  }
  .slide-right-enter-active .Inset, .slide-right-leave-active .Inset, .slide-left-enter-active .Inset, .slide-left-leave-active .Inset, .slide-right-enter .Inset, .slide-left-leave-to .Inset, .slide-right-enter-to .Inset, .slide-left-leave .Inset, .slide-right-leave .Inset, .slide-left-enter-to .Inset, .slide-left-enter .Inset, .slide-right-leave-to .Inset, .book-page .Inset {
    width: 100%;
  }
  .slide-right-enter-active .subA, .slide-right-leave-active .subA, .slide-left-enter-active .subA, .slide-left-leave-active .subA, .slide-right-enter .subA, .slide-left-leave-to .subA, .slide-right-enter-to .subA, .slide-left-leave .subA, .slide-right-leave .subA, .slide-left-enter-to .subA, .slide-left-enter .subA, .slide-right-leave-to .subA, .book-page .subA {
    font-weight: bold;
    line-height: 3rem;
  }
  .slide-right-enter-active ol, .slide-right-leave-active ol, .slide-left-enter-active ol, .slide-left-leave-active ol, .slide-right-enter ol, .slide-left-leave-to ol, .slide-right-enter-to ol, .slide-left-leave ol, .slide-right-leave ol, .slide-left-enter-to ol, .slide-left-enter ol, .slide-right-leave-to ol, .book-page ol {
    margin-left: 20px;
  }
  .slide-right-enter-active ol > li:last-child, .slide-right-leave-active ol > li:last-child, .slide-left-enter-active ol > li:last-child, .slide-left-leave-active ol > li:last-child, .slide-right-enter ol > li:last-child, .slide-left-leave-to ol > li:last-child, .slide-right-enter-to ol > li:last-child, .slide-left-leave ol > li:last-child, .slide-right-leave ol > li:last-child, .slide-left-enter-to ol > li:last-child, .slide-left-enter ol > li:last-child, .slide-right-leave-to ol > li:last-child, .book-page ol > li:last-child {
    margin-bottom: 16px;
  }
  .slide-right-enter-active td, .slide-right-leave-active td, .slide-left-enter-active td, .slide-left-leave-active td, .slide-right-enter td, .slide-left-leave-to td, .slide-right-enter-to td, .slide-left-leave td, .slide-right-leave td, .slide-left-enter-to td, .slide-left-enter td, .slide-right-leave-to td, .book-page td {
    border-right: 1px solid grey;
    border-bottom: 1px solid grey;
    padding: 10px;
    page-break-before: auto;
    page-break-after: auto;
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
    font-size: 12px;
  }
  .slide-right-enter-active td:first-child, .slide-right-leave-active td:first-child, .slide-left-enter-active td:first-child, .slide-left-leave-active td:first-child, .slide-right-enter td:first-child, .slide-left-leave-to td:first-child, .slide-right-enter-to td:first-child, .slide-left-leave td:first-child, .slide-right-leave td:first-child, .slide-left-enter-to td:first-child, .slide-left-enter td:first-child, .slide-right-leave-to td:first-child, .book-page td:first-child {
    border-left: 1px solid grey;
  }
  .slide-right-enter-active .headerRow, .slide-right-leave-active .headerRow, .slide-left-enter-active .headerRow, .slide-left-leave-active .headerRow, .slide-right-enter .headerRow, .slide-left-leave-to .headerRow, .slide-right-enter-to .headerRow, .slide-left-leave .headerRow, .slide-right-leave .headerRow, .slide-left-enter-to .headerRow, .slide-left-enter .headerRow, .slide-right-leave-to .headerRow, .book-page .headerRow {
    border: 1px solid grey;
  }
  .slide-right-enter-active .subheader, .slide-right-leave-active .subheader, .slide-left-enter-active .subheader, .slide-left-leave-active .subheader, .slide-right-enter .subheader, .slide-left-leave-to .subheader, .slide-right-enter-to .subheader, .slide-left-leave .subheader, .slide-right-leave .subheader, .slide-left-enter-to .subheader, .slide-left-enter .subheader, .slide-right-leave-to .subheader, .book-page .subheader {
    font-size: .9em;
    height: auto;
    display: block;
    width: 100%;
    font-style: italic;
  }
  .slide-right-enter-active {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-right-leave-active {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-left-enter-active {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-left-leave-active {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-right-enter {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-left-leave-to {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-right-enter-to {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-left-leave {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-right-leave {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-left-enter-to {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-left-enter {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-right-leave-to {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .book-page {
    #ncover, #nendpaper, #ntitle-page, .toc-nav, #nin1 {
      display: block;
      width: 100%;
    }
  }
  .slide-right-enter-active .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-right-leave-active .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-left-enter-active .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-left-leave-active .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-right-enter .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-left-leave-to .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-right-enter-to .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-left-leave .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-right-leave .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-left-enter-to .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-left-enter .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-right-leave-to .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .book-page .inner_page h1 {
    &.chapter0, &.chapter1, &.section {
      float: left;
    }
  }
  .slide-right-enter-active {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-right-leave-active {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-left-enter-active {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-left-leave-active {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-right-enter {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-left-leave-to {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-right-enter-to {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-left-leave {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-right-leave {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-left-enter-to {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-left-enter {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-right-leave-to {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .book-page {
    .book-title, .heading {
      margin-top: 40px;
    }
  }
  .slide-right-enter-active p, .slide-right-leave-active p, .slide-left-enter-active p, .slide-left-leave-active p, .slide-right-enter p, .slide-left-leave-to p, .slide-right-enter-to p, .slide-left-leave p, .slide-right-leave p, .slide-left-enter-to p, .slide-left-enter p, .slide-right-leave-to p, .book-page p {
    display: block !important;
    margin: 5px 0 !important;
  }
  .slide-right-enter-active p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-right-leave-active p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-left-enter-active p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-left-leave-active p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-right-enter p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-left-leave-to p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-right-enter-to p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-left-leave p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-right-leave p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-left-enter-to p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-left-enter p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-right-leave-to p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .book-page p {
    &.copy, &.copy1 {
      text-align: center;
    }
  }
  .slide-right-enter-active small, .slide-right-leave-active small, .slide-left-enter-active small, .slide-left-leave-active small, .slide-right-enter small, .slide-left-leave-to small, .slide-right-enter-to small, .slide-left-leave small, .slide-right-leave small, .slide-left-enter-to small, .slide-left-enter small, .slide-right-leave-to small, .book-page small {
    margin-left: -5px;
  }
  .slide-right-enter-active span.small, .slide-right-leave-active span.small, .slide-left-enter-active span.small, .slide-left-leave-active span.small, .slide-right-enter span.small, .slide-left-leave-to span.small, .slide-right-enter-to span.small, .slide-left-leave span.small, .slide-right-leave span.small, .slide-left-enter-to span.small, .slide-left-enter span.small, .slide-right-leave-to span.small, .book-page span.small {
    font-size: 0.8em;
  }
  .slide-right-enter-active h2.title, .slide-right-leave-active h2.title, .slide-left-enter-active h2.title, .slide-left-leave-active h2.title, .slide-right-enter h2.title, .slide-left-leave-to h2.title, .slide-right-enter-to h2.title, .slide-left-leave h2.title, .slide-right-leave h2.title, .slide-left-enter-to h2.title, .slide-left-enter h2.title, .slide-right-leave-to h2.title, .book-page h2.title {
    font-size: 34px !important;
    font-weight: 500 !important;
    line-height: 1 !important;
    letter-spacing: .02em !important;
  }
  .slide-right-enter-active .warning, .slide-right-leave-active .warning, .slide-left-enter-active .warning, .slide-left-leave-active .warning, .slide-right-enter .warning, .slide-left-leave-to .warning, .slide-right-enter-to .warning, .slide-left-leave .warning, .slide-right-leave .warning, .slide-left-enter-to .warning, .slide-left-enter .warning, .slide-right-leave-to .warning, .book-page .warning {
    background-color: #ffc107 !important;
    border-color: #ffc107 !important;
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    page-break-before: auto;
    page-break-after: auto;
    border-radius: 10px;
    padding: 5px 30px;
    border: 1px solid #ffc107 !important;
    border-radius: 10px;
  }
  .slide-right-enter-active .warning .title, .slide-right-leave-active .warning .title, .slide-left-enter-active .warning .title, .slide-left-leave-active .warning .title, .slide-right-enter .warning .title, .slide-left-leave-to .warning .title, .slide-right-enter-to .warning .title, .slide-left-leave .warning .title, .slide-right-leave .warning .title, .slide-left-enter-to .warning .title, .slide-left-enter .warning .title, .slide-right-leave-to .warning .title, .book-page .warning .title {
    margin-bottom: 10px;
  }
  .slide-right-enter-active .warning p, .slide-right-leave-active .warning p, .slide-left-enter-active .warning p, .slide-left-leave-active .warning p, .slide-right-enter .warning p, .slide-left-leave-to .warning p, .slide-right-enter-to .warning p, .slide-left-leave .warning p, .slide-right-leave .warning p, .slide-left-enter-to .warning p, .slide-left-enter .warning p, .slide-right-leave-to .warning p, .book-page .warning p {
    margin-bottom: 20px;
  }
}

.lib-item-size .input-group {
  width: 150px;
  position: absolute;
  right: 0;
  top: 50px;
  background-color: #f3f3f3;
  box-shadow: 5px 0 15px rgba(0, 0, 0, 0.1), -5px 0 15px rgba(0, 0, 0, 0.1);
  padding: 20px 10px;
}

.settings {
  color: #2c3e50;
  padding: 20px;
  margin-top: 30px;
  button.settings-link {
    outline: 0;
    border: 0;
    cursor: pointer;
    background: 0;
    margin-top: 10px;
    color: #2c3e50;
    font-size: 26px;
    border: 1px solid #dadada;
    padding: 0 1rem;
    &:hover {
      color: #fb8c00;
      border: 1px solid #fb8c00;
    }
  }
  .settings-container {
    color: #2c3e50;
    position: absolute;
    top: 57px;
    left: calc(50% - 255px);
    background: #f3f3f3;
    border-radius: 1px;
    padding: 30px;
    width: 450px;
    box-shadow: 0 2px 4px -1px rgba(44, 62, 80, 0.01), 0 4px 5px rgba(44, 62, 80, 0.01), 0 1px 10px rgba(44, 62, 80, 0.01);
    text-align: center;
    padding-bottom: 0;
    z-index: -10;
  }
  .settings-list {
    #reloadBookBtn {
      border: 1px solid #b6b5b3;
      border-radius: 100px;
      width: 40px;
      height: 40px;
      i {
        color: #4BACB8 !important;
        transform: scale(1.1);
      }
      &:hover, &:active, &:focus {
        border: 1px solid #6a6966;
      }
      &:hover i, &:active i, &:focus i {
        transform: scale(1);
      }
    }
    .menu__content--dropdown {
      box-shadow: 0 !important;
    }
    hr {
      border-color: rgba(44, 62, 80, 0.02);
      width: 100%;
    }
    li {
      margin-right: 10px;
      display: block;
      width: 100%;
      padding: 20px;
      &:first-child {
        margin-top: 10px;
        padding-bottom: 0;
      }
      span {
        float: left;
        font-size: 1.1rem;
      }
      #colors {
        margin: 0;
        padding: 0;
        width: 100%;
        button {
          font-size: 1.25rem;
          padding: 5px 10px;
          border: 1px solid #4BACB8 !important;
          border-radius: 1px;
          width: 85px;
          height: 50px;
          display: inline-block;
          margin: 0 0 3px;
        }
        #white {
          color: #2c3e50;
          border: 1px solid white !important;
          background-color: #f3f3f3 !important;
          &:hover, &:active, &:focus {
            color: #2c3e50;
            border: 1px solid white !important;
            background-color: #f3f3f3 !important;
          }
        }
        #black {
          color: #f3f3f3;
          border: 1px solid #f3f3f3 !important;
          background-color: #2C2F30 !important;
          &:hover, &:active, &:focus {
            color: #f3f3f3;
            background-color: #2C2F30 !important;
          }
        }
        #sepia {
          color: #2c3e50;
          border: 1px solid #dcc1a7 !important;
          background-color: #dcc1a7 !important;
          &:hover, &:active, &:focus {
            color: #2c3e50;
            border: 1px solid #dcc1a7 !important;
            background-color: #dcc1a7 !important;
          }
        }
      }
      .input-group .input-group--dirty .input-group .input-group--slider .input-group--ticks .input-group--active {
        color: blue !important;
        background-color: blue;
      }
    }
    input[type="radio"] {
      width: 30px;
      float: none;
      width: 20px;
    }
  }
}

.application--light .input-group.input-group--selection-controls {
  &.radio, &.checkbox {
    margin-bottom: 20px;
  }
}

.input-group--overflow .input-group__input:hover, .input-group--editable .input-group__input:hover, .input-group--segmented .input-group__input:hover {
  background: inherit;
}

.input-group--overflow.input-group--focused .input-group__input, .input-group--editable.input-group--focused .input-group__input, .input-group--segmented.input-group--focused .input-group__input {
  box-shadow: none;
  background: inherit;
}

.white {
  color: #2c3e50 !important;
  background-color: #f3f3f3 !important;
  .book-page, .bookTitle, .authorName, .publisherName, h1, h2, h3, h4, h5, h6, p.subheader {
    color: #2c3e50 !important;
  }
}

.black {
  color: #c4c4c4 !important;
  background-color: #2C2F30 !important;
  .book-page, .bookTitle, .authorName, .publisherName, h1, h2, h3, h4, h5, h6, p.subheader {
    color: #c4c4c4 !important;
  }
  a {
    color: #4BACB8;
    opacity: .7;
    transition: opacity .3s ease-out;
    &:hover, &:active, &:focus {
      opacity: 1;
    }
    &:not([href]) {
      color: #c4c4c4 !important;
      &:hover, &:active, &:focus {
        color: #c4c4c4 !important;
        opacity: .7;
      }
    }
  }
}

.sepia {
  color: #2c3e50 !important;
  background-color: #dcc1a7 !important;
  .book-page, .bookTitle, .authorName, .publisherName, h1, h2, h3, h4, h5, h6, p.subheader {
    color: #2c3e50 !important;
  }
}

.application {
  background-color: #233140;
}

.list-btn {
  display: block;
  width: 100%;
}

.navigation-drawer--permanent.navigation-drawer--clipped, .navigation-drawer--persistent.navigation-drawer--clipped, .navigation-drawer--permanent.navigation-drawer--floating, .navigation-drawer--persistent.navigation-drawer--floating {
  margin-top: 50px;
  max-height: calc(100vh - 50px);
}

.navigation-drawer--permanent.navigation-drawer--clipped ~ .toolbar, .navigation-drawer--persistent.navigation-drawer--clipped ~ .toolbar, .navigation-drawer--permanent.navigation-drawer--floating ~ .toolbar, .navigation-drawer--persistent.navigation-drawer--floating ~ .toolbar, .navigation-drawer--permanent.navigation-drawer--clipped ~ .footer.footer--fixed, .navigation-drawer--persistent.navigation-drawer--clipped ~ .footer.footer--fixed, .navigation-drawer--permanent.navigation-drawer--floating ~ .footer.footer--fixed, .navigation-drawer--persistent.navigation-drawer--floating ~ .footer.footer--fixed, .navigation-drawer--permanent.navigation-drawer--clipped ~ .footer.footer--absolute, .navigation-drawer--persistent.navigation-drawer--clipped ~ .footer.footer--absolute, .navigation-drawer--permanent.navigation-drawer--floating ~ .footer.footer--absolute, .navigation-drawer--persistent.navigation-drawer--floating ~ .footer.footer--absolute {
  z-index: 5;
}

.navigation-drawer {
  overflow: hidden;
  z-index: 3;
  margin-right: -20px;
  padding: 0;
  ul.list {
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
    li {
      padding-top: 10px;
    }
  }
}

.Old-Cabin {
  font-family: 'Old Standard TT' !important;
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Cabin' !important;
  }
}

.Raleway-Bitter {
  font-family: 'Raleway' !important;
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Bitter' !important;
  }
}

.Ubuntu-Abel {
  font-family: 'Ubuntu' !important;
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Abel' !important;
  }
}

.Droid-Abril {
  font-family: 'Droid Sans' !important;
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Abril Fatface' !important;
  }
}

.Garamond-Clicker {
  font-family: 'EB Garamond' !important;
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Clicker Script' !important;
  }
}

.Alice-Playfair {
  font-family: 'Alice' !important;
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Playfair Display' !important;
  }
}

.Judson-Quando {
  font-family: 'Judson' !important;
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Quando' !important;
  }
}

h1, .bookTitle, .book-content .book-page h1 {
  font-size: 55px !important;
  line-height: 60px !important;
  float: none !important;
  margin-top: 5vh;
  display: inline-block !important;
}

.bookDescription {
  font-style: italic;
}

.authorName {
  font-size: 2.5rem;
}

.authorDescription {
  font-style: italic;
}

.publisherName {
  font-size: 2rem;
  margin-top: 20px;
}

.slide-leave-active, .slide-enter-active {
  transition: all .3s ease;
}

.slide-enter {
  transform: translate3d(100%, 0, 0);
  -webkit-transform: translate3d(100%, 0, 0);
  opacity: 0;
}

.slide-leave-to {
  transform: translate3d(-100%, 0, 0);
  -webkit-transform: translate3d(-100%, 0, 0);
  opacity: 0;
}

.menu .menu__activator--active {
  color: #4BACB8 !important;
  background: rgba(44, 62, 80, 0) !important;
  border: 0n;
}

.inner_page h1 {
  &.section, &.chapter1, &.chapter0 {
    font-size: 42px;
  }
}

.authorInfo p > {
  span, em {
    font-size: 33px;
    font-family: fontFamily;
    font-style: italic;
    background-color: #f3f3f3 !important;
  }
}

.toc span.black {
  background-color: #f3f3f3 !important;
  color: #2c3e50 !important;
}

code, kbd {
  white-space: normal;
}

code {
  &:after, &:before {
    contain: '';
  }
}

kbd {
  &:after, &:before {
    contain: '';
  }
}

.slide-right-enter-active, .slide-right-leave-active, .slide-left-enter-active, .slide-left-leave-active {
  position: absolute;
}

.slide-right-enter, .slide-left-leave-to {
  transform: translate3d(-100%, 0, 0);
  transition: transform 0.35s cubic-bezier(0, 0.74, 0.36, 1);
  position: absolute;
}

.slide-right-enter-to, .slide-left-leave, .slide-right-leave, .slide-left-enter-to {
  transform: translate3d(0, 0, 0);
  transition: transform 0.35s cubic-bezier(0, 0.74, 0.36, 1);
  position: absolute;
}

.slide-left-enter, .slide-right-leave-to {
  transform: translate3d(100%, 0, 0);
  transition: transform 0.35s cubic-bezier(0, 0.74, 0.36, 1);
  position: absolute;
}

.touch-swipe {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  &.active {
    display: none;
  }
}

.frontMatter h1 {
  font-size: 50px !important;
}

span {
  &.dropcap {
    float: left;
  }
  &.drop-cap {
    font-size: 2.8em;
    line-height: 1em;
    padding-top: 4px;
    padding-right: 8px;
    padding-left: 3px;
    float: left;
  }
}

#toc ol, .hide1 ol {
  list-style: none;
}

#toc {
  ol li {
    &:nth-child(n+1):nth-child(n+5) {
      text-align: left;
    }
    &.toc {
      padding-left: 0 !important;
    }
  }
  li {
    &:nth-child(1), &:nth-child(2), &:nth-child(3), &:nth-child(4), &:nth-child(5) {
      padding-left: 0;
    }
  }
}

#nav ol {
  list-style: none;
}

.bullett img.block, .bullet img.block {
  margin-left: 0;
}

p {
  &.c15 span {
    float: left;
  }
  &.P_Body_Text > span {
    font-size: 2.5em;
    font-weight: bolder;
    display: inline-block;
    margin-right: -2px;
  }
  &.section-break {
    text-align: center;
  }
}

.chapter-title-corner-decorations table {
  display: none;
}

.smallcaps {
  text-transform: lowercase !important;
  margin-left: -5px !important;
}

.copyright {
  text-align: center;
}

.authorInfo p > {
  span, em {
    font-size: 33px;
    font-family: fontFamily;
    font-style: italic;
    background-color: #f3f3f3 !important;
  }
}

.toc span.black {
  background-color: #f3f3f3 !important;
  color: #2c3e50 !important;
}

@media screen and (max-device-width: 768px) {
  body {
    overflow: hidden;
  }
  nav.main-menu .HC, .toolbar .HC, .toolbar--fixed .HC, .toolbar__content .HC {
    width: 40px !important;
  }
  nav.main-menu button.btn, .toolbar button.btn, .toolbar--fixed button.btn, .toolbar__content button.btn {
    width: auto !important;
    min-width: auto !important;
  }
  .nav-btn {
    display: none !important;
  }
  ul#colors {
    button {
      border: 0;
    }
    #white {
      color: #2c3e50;
      border: 1px solid #f3f3f3 !important;
      background-color: #f3f3f3 !important;
    }
    #black {
      color: #f3f3f3;
      border: 1px solid #2C2F30 !important;
      background-color: #2C2F30 !important;
    }
    #sepia {
      color: #2c3e50;
      border: 1px solid #dcc1a7 !important;
      background-color: #dcc1a7 !important;
    }
  }
  .book-content {
    width: 100vw !important;
    min-width: 0 !important;
    .book-page {
      page-break-before: auto !important;
      page-break-after: auto !important;
      -webkit-column-break-inside: avoid !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
      .coverImage, .seperator img, img {
        page-break-before: auto !important;
        page-break-after: auto !important;
        -webkit-column-break-inside: avoid !important;
        page-break-inside: avoid !important;
        break-inside: avoid !important;
        /*margin-left: 50% !important;*/
        transform: translate(0%, 0);
      }
      ul > li {
        max-width: 90% !important;
      }
    }
  }
  .mobile-social-btn {
    display: block;
    width: 20vw;
    span {
      display: none;
    }
  }
  .desktop-social-btn {
    display: none;
  }
}

@media only screen and (max-device-width: 480px) {
  .lib-item-size .input-group {
    width: 150px;
    position: absolute;
    right: 0;
    top: 50px;
    background-color: #f3f3f3;
    box-shadow: 5px 0 15px rgba(0, 0, 0, 0.1), -5px 0 15px rgba(0, 0, 0, 0.1);
    padding: 20px;
  }
  nav.main-menu button.btn, .toolbar button.btn, .toolbar--fixed button.btn, .toolbar__content button.btn {
    width: auto !important;
    min-width: auto !important;
  }
  .settings {
    margin-top: 20px;
  }
  .columns-setting, .width-setting {
    display: none !important;
  }
  .slider__thumb {
    width: 35px;
    height: 35px;
    border: 1px inset 3px solid #f3f3f3;
  }
  .book-content {
    padding: 20px !important;
    .slide-right-enter-active, .slide-right-leave-active, .slide-left-enter-active, .slide-left-leave-active, .slide-right-enter, .slide-left-leave-to, .slide-right-enter-to, .slide-left-leave, .slide-right-leave, .slide-left-enter-to, .slide-left-enter, .slide-right-leave-to, .book-page {
      font-size: 22px;
      overflow-y: hidden;
      page-break-before: auto !important;
      page-break-after: auto !important;
      -webkit-column-break-inside: avoid !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
      columns: 220px 1 !important;
      column-gap: 20px !important;
    }
    .slide-right-enter-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .book-page {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .slide-right-leave-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .slide-left-enter-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .slide-left-leave-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .slide-right-enter {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .slide-left-leave-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .slide-right-enter-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .slide-left-leave {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .slide-right-leave {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .slide-left-enter-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .slide-left-enter {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .slide-right-leave-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
    .book-page {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 175px) !important;*/
        max-width: calc(100vw - 40px) !important;
      }
    }
  }
}

@media only screen and (max-width: 735px) and (orientation: landscape) {
  .book-content {
    .slide-right-enter-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .book-page {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 30px !important;
        line-height: 33px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter-active {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .slide-right-leave-active {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .slide-left-enter-active {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .slide-left-leave-active {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .slide-right-enter {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .slide-left-leave-to {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .slide-right-enter-to {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .slide-left-leave {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .slide-right-leave {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .slide-left-enter-to {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .slide-left-enter {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .slide-right-leave-to {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 170px) !important;
      }
    }
    .book-page {
      .coverImage, .seperator img, /**img**/ {
        /**max-height: calc(100vh - 170px) !important;**/
      }
    }
  }
}

@media screen and (max-width: 1023px) {
  .mobile-buy-btn {
    display: block;
    span {
      display: none;
    }
  }
}

@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .book-content {
    padding: 20px !important;
    .slide-right-enter-active, .slide-right-leave-active, .slide-left-enter-active, .slide-left-leave-active, .slide-right-enter, .slide-left-leave-to, .slide-right-enter-to, .slide-left-leave, .slide-right-leave, .slide-left-enter-to, .slide-left-enter, .slide-right-leave-to, .book-page {
      font-size: 22px;
      overflow-y: hidden;
      page-break-before: auto !important;
      page-break-after: auto !important;
      -webkit-column-break-inside: avoid !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
      columns: 220px 1 !important;
      column-gap: 20px !important;
    }
    .slide-right-enter-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .book-page {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-right-leave-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-enter-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-leave-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-right-enter {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-leave-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-right-enter-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-leave {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-right-leave {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-enter-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-enter {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-right-leave-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .book-page {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
  }
}

@media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) {
  .book-content {
    padding: 20px !important;
    .slide-right-enter-active, .slide-right-leave-active, .slide-left-enter-active, .slide-left-leave-active, .slide-right-enter, .slide-left-leave-to, .slide-right-enter-to, .slide-left-leave, .slide-right-leave, .slide-left-enter-to, .slide-left-enter, .slide-right-leave-to, .book-page {
      font-size: 22px;
      overflow-y: hidden;
      page-break-before: auto !important;
      page-break-after: auto !important;
      -webkit-column-break-inside: avoid !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
      columns: 220px 1 !important;
      column-gap: 20px !important;
    }
    .slide-right-enter-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .book-page {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-right-leave-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-enter-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-leave-active {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-right-enter {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-leave-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-right-enter-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-leave {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-right-leave {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-enter-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-left-enter {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .slide-right-leave-to {
      .coverImage, .seperator img, img {
        /*max-height: calc(100vh - 110px) !important;*/
      }
    }
    .book-page {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
  }
}

@media only screen and (device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) {
  .book-content {
    padding: 20px !important;
    .slide-right-enter-active, .slide-right-leave-active, .slide-left-enter-active, .slide-left-leave-active, .slide-right-enter, .slide-left-leave-to, .slide-right-enter-to, .slide-left-leave, .slide-right-leave, .slide-left-enter-to, .slide-left-enter, .slide-right-leave-to, .book-page {
      font-size: 22px;
      overflow-y: hidden;
      page-break-before: auto !important;
      page-break-after: auto !important;
      -webkit-column-break-inside: avoid !important;
      page-break-inside: avoid !important;
      break-inside: avoid !important;
      columns: 220px 1 !important;
      column-gap: 20px !important;
    }
    .slide-right-enter-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave-active {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-leave {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-left-enter {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-leave-to {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .book-page {
      .book-content .book-page h1, .bookTitle, h1 {
        font-size: 40px !important;
        line-height: 45px !important;
        display: inline-block !important;
      }
    }
    .slide-right-enter-active {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .slide-right-leave-active {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .slide-left-enter-active {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .slide-left-leave-active {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .slide-right-enter {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .slide-left-leave-to {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .slide-right-enter-to {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .slide-left-leave {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .slide-right-leave {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .slide-left-enter-to {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .slide-left-enter {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .slide-right-leave-to {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
    .book-page {
      .coverImage, .seperator img, img {
        max-height: calc(100vh - 110px) !important;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// Reader.vue?42e8fe14